import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SupplierLookupResponseModel } from '../models/supplier-lookup-response-model';
import { SupplierLookupService } from '../supplier-lookup.service';

@Component({
    selector: 'edit-supplier-lookup',
    standalone: true,
    imports: [CommonModule, FormsModule],
    providers: [SupplierLookupService],
    templateUrl: './edit-supplier-lookup.component.html'
})
export class EditSupplierLookupComponent implements OnInit {
    @Input() supplierLookup: SupplierLookupResponseModel;
    @Input() isNew: boolean = false;

    public model: SupplierLookupResponseModel;
    public isSaving: boolean = false;
    public errorMessage: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private supplierLookupService: SupplierLookupService
    ) {}

    ngOnInit(): void {
        if (this.isNew) {
            this.model = {
                siteId: '',
                supplierId: '',
                siteName: ''
            };
        } else {
            this.model = { ...this.supplierLookup };
        }
    }

    public save() {
        this.isSaving = true;
        this.errorMessage = '';

        if (this.isNew) {
            this.supplierLookupService.create(this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to create the supplier lookup entry. Please try again.';
                }
            });
        } else {
            this.supplierLookupService.update(this.supplierLookup.siteId, this.supplierLookup.supplierId, this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to update the supplier lookup entry. Please try again.';
                }
            });
        }
    }

    public cancel() {
        this.activeModal.dismiss('cancel');
    }
}
